module.exports = __webpack_public_path__ + "img/1.735ee599.jpg";